/*
 * Search bar for attributes that are set to be searchable
 */
import React from 'react'
import Button from 'react-bootstrap/Button'
import InputGroup from 'react-bootstrap/InputGroup'
import FormControl from 'react-bootstrap/FormControl'

import debounce from '../../../utils/debounce.js'

/**
 * Input type search to relay debounced values to the handler
 * reponsible for sending queries to the backend.
 */
const Search = ({ disabled, handleSearchInput }) => {
  const debounceMs = 500

  return (
    <InputGroup className='d-inline-flex mb-3 shadow-sm search-container'>
      <FormControl
        className='border-0 search-input'
        placeholder='Search table'
        onChange={debounce(handleSearchInput, debounceMs)}
        aria-label="Recipient's username"
        aria-describedby='basic-addon2'
        disabled={disabled}
      />
      <InputGroup.Append>
        <Button variant='normal' aria-label='search'>
          <i className='fas fa-search' />
        </Button>
      </InputGroup.Append>
    </InputGroup>
  )
}

export default Search
